module.exports = __webpack_public_path__ + "media/images/Logo_Proef_de_Perfectie-ecc020cce46bce2205f93b6b5a90afbb.png";